<template>
	<v-sheet rounded>
		<v-card color="#125B92">
			<v-card-title v-if="titleBar" class="align-center">
				<v-icon left large color="#E3ECF2">mdi-folder</v-icon>
				<h3 class="white--text">{{ title }}</h3>
				<v-spacer />
				<slot />
			</v-card-title>

			<v-divider v-if="titleBar" class="thick" />

			<v-data-table
				:headers="tableHeaders"
				:items="items"
				:loading="loading"
				:footer-props="{
					'items-per-page-options': [10, 20, 30, 40, 50]
				}"
				:page.sync="filters.page"
				:items-per-page.sync="filters.paginated"
				:server-items-length="totalPayments"
				:sort-by.sync="filters.sort"
				:sort-desc.sync="filters.descending"
				class="table-stripped">
				<template #top>
					<v-toolbar flat>
						<v-spacer />
						<div class="flex-fill datatable-filter-large">
							<v-text-field
								v-model.trim="filters.search"
								class="table-search"
								append-icon="mdi-magnify"
								placeholder="Search..."
								name="search"
								autocomplete="off"
								single-line
								clearable
								filled
								outlined
								dense
								full-width
								autofocus
								hide-details />
						</div>
						<div class="ml-3">
							<v-chip>{{ totalPayments | numeric }}</v-chip>
						</div>
					</v-toolbar>
				</template>
				<template #item.id="{ item }">
					#{{ item.id }}
				</template>

				<template #item.invoice_id="{ item }">
					<Link v-if="item.invoice_id" :href="route('invoices.show', item.invoice_id)">#{{ item.invoice_id }}</Link>
					<span v-else>--</span>
				</template>

				<template #item.payee="{ item }">
					{{ item.payee }}
				</template>

				<template #item.amount="{ item }">
					<div class="font-mono">{{ item.amount | money }}</div>
				</template>

				<template #item.transaction_id="{ item }">
					<span class="font-mono">{{ item.transaction_id || '--' }}</span>
				</template>

				<template #item.type="{ item }">
					<v-chip v-if="item.type"
						label
						small
						color="grey lighten-3"
						class="text-capitalize">
						{{ item.type }}
					</v-chip>
					<em v-else class="grey--text">Unknown</em>
				</template>

				<template #item.paid_on="{ item }">
					{{ item.paid_on | humanDate }}
				</template>

				<template #item.actions="{ item }">
					<delete-button small
						icon
						model="payments"
						:model-id="item.id"
						:only="['invoices', 'invoice', 'payments', 'counts', 'flash']">
						<v-icon color="danger">
							mdi-delete
						</v-icon>
					</delete-button>
				</template>
			</v-data-table>
		</v-card>
	</v-sheet>
</template>
<script>
import _ from 'lodash'
import api from '@/api'
import DeleteButton from '@/Pages/Backend/Components/DeleteButton'

export default {
	components: { DeleteButton },
	props: {
		title: {
			type: String,
			default: 'Payments'
		},
		payments: {
			type: [Array, Object],
			default: () => {},
			required: true
		},
		titleBar: {
			type: Boolean,
			default: () => false
		}
	},
	data () {
		return {
			filters: {
				search: '',
				status: '',
				paginated: 30,
				page: 1,
				descending: true,
				sort: 'id'
			},
			statuses: [],
			loading: true,
			items: this.payments.data,
			tableHeaders: [
				{
					text: 'Payment',
					sortable: false,
					align: 'start',
					value: 'id'
				},
				{
					text: 'Invoice',
					sortable: false,
					align: 'center',
					value: 'invoice_id'
				},
				{
					text: 'Transaction ID',
					sortable: false,
					align: 'center',
					value: 'transaction_id'
				},
				{
					text: 'Type',
					sortable: false,
					value: 'type'
				},
				{
					text: 'Payee',
					sortable: false,
					align: 'start',
					value: 'payee'
				},
				{
					text: 'Amount',
					sortable: false,
					align: 'center',
					value: 'amount'
				},
				{
					text: 'Paid On',
					sortable: false,
					align: 'start',
					value: 'paid_on'
				},
				{
					text: '',
					sortable: false,
					align: 'end',
					value: 'actions'
				}
			]
		}
	},
	computed: {
		totalPayments () {
			if (this.payments && this.payments.hasOwnProperty('meta')) {
				return this.payments.meta.total
			}

			return 0
		}
	},
	watch: {
		'filters.search': {
			handler: _.debounce(function () {
				this.getPayments()
			}, 350)
		},

		payments () {
			if (this.payments.hasOwnProperty('data')) {
				this.items = this.payments.data
				this.loading = false
			} else {
				this.items = []
			}
		}
	},
	mounted () {
		if (this.payments.hasOwnProperty('data')) {
			this.items = this.payments.data
			this.loading = false
		}

		if (this.$page.props.filters) {
			this.filters = this.$page.props.filters
		}

		this.$watch(vm => [vm.filters.paginated, vm.filters.page], val => {
			this.getPayments()
		})
	},
	methods: {
		getPayments () {
			this.$inertia.reload({
				onStart: () => this.loading = true,
				onFinish: () => {
					this.loading = false

					if(! this.length(this.items) && this.filters.page > 1) {
						this.filters.page = 1
					}
				},
				only: ['payments', 'counts'],
				data: this.filters
			})
		}
	}
}
</script>
